import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '@app/core/app-config';
import { map, catchError } from 'rxjs/operators';
import { FilterService } from '../filter/filter.service';
import { ErrorService } from '../error/error.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionService {
  private intentsUrl = `${config.API_URL}/intents/`;
  private detectUrl = `${config.API_URL}/intents/simulate`;

  constructor(
    private http: HttpClient,
    private filterService: FilterService,
    private errorService: ErrorService
  ) {}

  getIntents(filterCriteria?: any[], offset?: number, search?: string): Observable<any> {
    let apiFilters: any[];

    if (filterCriteria) {
      apiFilters = this.filterService.transformFilters(filterCriteria);
    }

    let url;

    url = `${this.intentsUrl}?`;

    if (offset) {
      url = `${url}&offset=${offset}`;
    }

    if (search) {
      url = `${url}&query=${search}`;
    }

    return this.http.post(url, { filters: apiFilters }).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getIntent(uuid: string) {
    const url = `${this.intentsUrl}${uuid}`;

    return this.http.get(url).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  deleteIntent(uuid: string) {
    const url = `${this.intentsUrl}${uuid}`;

    return this.http.delete(url).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  createIntent(name: string) {
    return this.http.post(`${this.intentsUrl}create`, { name }).pipe(
      map((res) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  updateIntent(uuid: string, examples: string[]): Observable<any> {
    const url = `${this.intentsUrl}${uuid}`;

    return this.http.put(url, { examples: examples }).pipe(
      map((res) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  runDetection(testString: string): Observable<any> {
    return this.http
      .post(this.detectUrl, {
        message: testString,
      })
      .pipe(
        map((res: any) => {
          return res.data.questions;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(err) {
    return of({
      error: true,
      message: err.error.message,
    });
  }
}
